export default __webpack_public_path__ + "static/media/about-us-2.69c54d2a.png";